import React from 'react'
import {
  makeStyles,
  Box,
  Button,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Input,
} from '@material-ui/core'
import { Link } from 'react-router-dom'
import Oculto from './Oculto'

const estilos = makeStyles((theme) => ({
  botonPersonalizado: {
    background: 'linear-gradient(45deg, #018786 30%, #018786 90%)',
    border: 0,
    borderRadius: 100,
    color: 'white',
    height: 48,
    padding: '5px 20px',
    fontSize: 20,
    fontWeight: 400,
    width: 140,
    marginBottom: 50,
  },
}))

const Test = ({ formState, handleChange }) => {
  const classes = estilos()

  return (
    <Grid container direction="column" justify="center" alignItems="center">
      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Box ml={4} mb={4} mt="15%">
          <Typography variant="h2" color="initial">
            Datos Personales
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Box mx={4} mb={6} alignItems="left">
          <Typography variant="body2">
            Ingresa tus nombre y edad para fines estadísticos.
          </Typography>
        </Box>
      </Grid>

      <FormControl>
        <InputLabel htmlFor="my-input">Tu nombre</InputLabel>
        <Input
          id="my-input"
          aria-describedby="my-helper-text"
          name="name"
          value={formState.name}
          onChange={handleChange}
        />
      </FormControl>

      <FormControl>
        <InputLabel htmlFor="my-input">Tu edad</InputLabel>
        <Input
          id="my-input"
          aria-describedby="my-helper-text"
          type="number"
          name="age"
          value={formState.age}
          onChange={handleChange}
        />
      </FormControl>

      <Box mt={4}>
        {formState.name !== '' && formState.age !== 0 && formState.age >= 0 ? (
          <Link to="/TestParteUno" className="navbarLinks">
            <Button
              size="large"
              className={classes.botonPersonalizado}
              disableElevation
            >
              INGRESAR
            </Button>
          </Link>
        ) : (
          <Button
            size="large"
            className={classes.botonPersonalizado}
            disableElevation
            disabled
          >
            INGRESAR
          </Button>
        )}
      </Box>

      <Grid item>
        <Box ml={4}>
          <Typography variant="body2">
            Si eres menor de edad, pide ayuda a un adulto.
          </Typography>
        </Box>
      </Grid>

      {/* <Oculto /> */}
    </Grid>
  )
}

export default Test
